// Coordenadas-base por bairro pra fallback enquanto a auto-geocodificacao
// nao esta implementada. Cada imovel sem latitude/longitude real ganha
// uma coordenada perto do centro do bairro com um pequeno offset
// deterministico baseado no id (pra eles nao empilharem no mesmo pin).

const BAIRRO_COORDS = {
  'Alphaville': { lat: -23.4856, lng: -46.8533 },
  'Tamboré': { lat: -23.4795, lng: -46.8322 },
  'Barueri Centro': { lat: -23.5107, lng: -46.876 },
  'Pinhal': { lat: -23.3147, lng: -47.1356 },
};

const CIDADE_COORDS = {
  'Barueri': { lat: -23.5107, lng: -46.876 },
  'Cabreuva': { lat: -23.3079, lng: -47.1325 },
  'Cabreúva': { lat: -23.3079, lng: -47.1325 },
  'Bertioga': { lat: -23.7855, lng: -46.0731 },
  'Santos': { lat: -23.9608, lng: -46.3331 },
  'Guarujá': { lat: -23.9931, lng: -46.2564 },
  'Guaruja': { lat: -23.9931, lng: -46.2564 },
  'São Paulo': { lat: -23.5505, lng: -46.6333 },
  'Sao Paulo': { lat: -23.5505, lng: -46.6333 },
  'Santana de Parnaíba': { lat: -23.4436, lng: -46.9178 },
  'Santana de Parnaiba': { lat: -23.4436, lng: -46.9178 },
  'Osasco': { lat: -23.5325, lng: -46.7917 },
  'Carapicuíba': { lat: -23.5226, lng: -46.8358 },
  'Carapicuiba': { lat: -23.5226, lng: -46.8358 },
  'Jandira': { lat: -23.5275, lng: -46.9019 },
  'Itapevi': { lat: -23.5489, lng: -46.9342 },
};

const BAIRRO_COORDS_EXTRA = {
  'Riviera - Ilha Bali': { lat: -23.7572, lng: -45.9989 },
  'Riviera': { lat: -23.7572, lng: -45.9989 },
  'Riviera de São Lourenço': { lat: -23.7572, lng: -45.9989 },
  'Riviera de Sao Lourenco': { lat: -23.7572, lng: -45.9989 },
};

const DEFAULT_COORDS = { lat: -23.4856, lng: -46.8533 }; // Alphaville

// Hash deterministico simples — converte uma string em um numero entre 0 e 1
function hashToFloat(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash % 1000) / 1000;
}

// Offset pequeno (~150-300m) baseado no id, pra pins nao empilharem
function offsetFromId(id, axis) {
  const seed = hashToFloat(`${id}-${axis}`);
  return (seed - 0.5) * 0.004; // ~444m em latitude
}

export function getPropertyCoords(property) {
  // Aceita numero OU string. Troca virgula decimal por ponto (ex.: "-23,7572")
  // e so usa a coordenada se ela for um numero finito de verdade — senao
  // cai no fallback por bairro/cidade. Coordenada NaN derrubava o Leaflet
  // (Invalid LatLng) e dava tela branca no detalhe do imovel.
  const toNum = (v) => {
    if (v == null) return NaN;
    if (typeof v === 'string') {
      const s = v.replace(',', '.').trim();
      return s === '' ? NaN : Number(s);
    }
    return Number(v);
  };
  const lat = toNum(property.latitude);
  const lng = toNum(property.longitude);
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return { lat, lng, real: true };
  }

  const base =
    BAIRRO_COORDS[property.bairro] ||
    BAIRRO_COORDS_EXTRA[property.bairro] ||
    CIDADE_COORDS[property.cidade] ||
    DEFAULT_COORDS;

  return {
    lat: base.lat + offsetFromId(property.id, 'lat'),
    lng: base.lng + offsetFromId(property.id, 'lng'),
    real: false,
  };
}
